import { useMemo } from 'react';
import { HistoryMovement } from 'types';

type UseGetPaginationDataProps = {
  page: number;
  rowsPerPage: number;
  historyMovements?: HistoryMovement[];
};

export const useGetPaginationData = ({
  page,
  rowsPerPage,
  historyMovements = [],
}: UseGetPaginationDataProps) => {
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const paginatedHistoryMovements = useMemo(
    () => historyMovements.slice(startIndex, endIndex),
    [historyMovements, startIndex, endIndex]
  );

  return {
    data: {
      paginatedHistoryMovements,
    },
  };
};
